import { FunctionComponent, MouseEvent } from 'react'

import { Grid, Box, Tooltip, Button } from '@material-ui/core'
import { MdSend } from 'react-icons/md'

import Card from 'shared/components/Card'
import { registerEvent } from 'shared/services/TrackingGAService'
import Formatter, { numberToCurrency } from 'shared/utils/formatters'
import IconLoteDirecionado from 'shared/assets/icons/icon-lote-direcionado.png'

import { ILoteCardProps } from './CardComponent.types'
import {
  ItemContainer,
  Subtitle,
  Title,
  TagProduto,
  IconLoteDirecionadoCard,
  Logomarca,
  GridCard,
} from './styles'
import { useDirecionaCarga } from 'modules/lotes/hooks/direcionaCarga'
import IFindByIdResponse from '../../../domain/entities/FindByIdResponse'

const LoteCard: FunctionComponent<ILoteCardProps> = ({
  lote: loteSelecionado,
  index,
  lotes,
  onClickEnviarCarga,
  onClickVisualizar,
}) => {
  const MAX_STRING = 15
  const { setLote } = useDirecionaCarga()

  const enviarCarga = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    registerEvent({
      categoria: 'Direcionamento de Carga',
      acao: 'Click Enviar Carga',
      local: 'Botao no Card do Lote',
    })

    const lote: IFindByIdResponse = {
      id: loteSelecionado.id,
      destino: loteSelecionado.destino,
      origem: loteSelecionado.origem,
      produto: loteSelecionado.produto,
      recebedor: undefined,
    }
    setLote(lote)

    onClickEnviarCarga(
      loteSelecionado.id,
      loteSelecionado.origem,
      loteSelecionado.destino,
      loteSelecionado.valor,
    )
  }

  const visualizarDetalhesCarga = () => {
    registerEvent({
      categoria: 'Visualização',
      acao: 'Click Detalhes Carga',
      local: 'Botao no Card do Lote',
    })

    onClickVisualizar(loteSelecionado, lotes, index)
  }

  const renderSubtitle = subtitle => {
    if (subtitle?.length > MAX_STRING) {
      return (
        <Tooltip
          placement="top"
          title={Formatter.textoCapitular(subtitle)}
          arrow
        >
          <Subtitle>{subtitle.substring(0, MAX_STRING)}...</Subtitle>
        </Tooltip>
      )
    }

    return <Subtitle>{subtitle}</Subtitle>
  }

  return (
    <GridCard>
      <Tooltip placement="top" title="Carga direcionada por um parceiro" arrow>
        <IconLoteDirecionadoCard
          src={IconLoteDirecionado}
          className={!loteSelecionado.lote_direcionado ? 'hidden' : ''}
        />
      </Tooltip>
      <Card
        onClick={visualizarDetalhesCarga}
        className={`card-height card-lote-${loteSelecionado.id}`}
      >
        <Grid container direction={'row'}>
          <Grid item xs={6}>
            <ItemContainer>
              <Box display={'flex'} flexDirection={'column'}>
                <Title>Origem</Title>
                {renderSubtitle(loteSelecionado.origem)}
              </Box>
            </ItemContainer>

            <ItemContainer margin={25}>
              <Box display={'flex'} flexDirection={'column'}>
                <Title>Destino</Title>
                {renderSubtitle(loteSelecionado.destino)}
              </Box>
            </ItemContainer>

            {loteSelecionado.empresa_logomarca != null && (
              <Box display={'flex'} flexDirection={'column'}>
                <Title>Transportadora</Title>
                <Logomarca>
                  <img src={loteSelecionado.empresa_logomarca} />
                </Logomarca>
              </Box>
            )}
          </Grid>

          <Grid item xs={6}>
            <ItemContainer margin={4}>
              <Box display={'flex'} flexDirection={'column'} alignItems={'end'}>
                <Title>Preço {loteSelecionado.tipo_pagamento}</Title>
                <Subtitle>{numberToCurrency(loteSelecionado.valor)}</Subtitle>
              </Box>
            </ItemContainer>

            <Box display={'flex'} flexDirection={'column'} alignItems={'end'}>
              <ItemContainer margin={14}>
                <Title> {loteSelecionado.tipo_pedagio ?? 'Sem pedágio'}</Title>
              </ItemContainer>
              <ItemContainer margin={25}>
                <TagProduto>{loteSelecionado.produto.toLowerCase()}</TagProduto>
              </ItemContainer>
              {loteSelecionado.cliente_logomarca != null && (
                <Box display={'flex'} flexDirection={'column'}>
                  <Title>Embarcador</Title>
                  <Logomarca>
                    <img src={loteSelecionado.cliente_logomarca} />
                  </Logomarca>
                </Box>
              )}
            </Box>
          </Grid>

          <Button
            fullWidth
            className={`card-button
              ${
                loteSelecionado.cliente_logomarca == null ||
                loteSelecionado.empresa_logomarca == null
                  ? 'card-button-mt'
                  : ''
              }`}
            aria-label={`btn-enviar-carga-${loteSelecionado.id}`}
            type="submit"
            onClick={enviarCarga}
            startIcon={<MdSend style={{ fontSize: '14px' }} />}
          >
            Enviar carga
          </Button>
        </Grid>
      </Card>
    </GridCard>
  )
}

export default LoteCard
